/**
 * AOS Observer Utility
 * Detects DOM mutations and triggers callbacks when elements with AOS attributes are added or removed.
 */

let callback = () => {};

// Helper: Check if any nodes contain AOS-related attributes
const containsAOSNode = (nodes) => {
	for (const node of nodes) {
		if (node.dataset?.aos) return true;
		if (node.children?.length && containsAOSNode([...node.children])) return true;
	}
	return false;
};

// Helper: Get MutationObserver cross-browser
const getMutationObserver = () =>
	window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

// Check if MutationObserver is supported
const isSupported = () => !!getMutationObserver();

// Initialize observer for AOS elements
const ready = (selector, fn) => {
	const MutationObserver = getMutationObserver();
	if (!MutationObserver) return;

	const observer = new MutationObserver(checkMutations);
	callback = fn;

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
		removedNodes: true,
	});
};

// Process DOM mutations
const checkMutations = (mutations) => {
	if (!mutations) return;

	for (const mutation of mutations) {
		const allNodes = [...mutation.addedNodes, ...mutation.removedNodes];
		if (containsAOSNode(allNodes)) {
			callback();
			break; // Stop further checks after the first match
		}
	}
};

export default { isSupported, ready };
